import { useCallback, useState } from "react";

import Router from "next/router";

import submitDataAsForm from "@utils/submitDataAsForm";

import { PaymentSource } from "../constants";
import submitPayment from "../services/submitPayment";
import getRedirectPath from "../utils/getRedirectPath";

type TExecutePayment = {
  isSuccess: boolean;
  overDue: boolean;
}

type TPaymentReturn = {
  isLoading: boolean;
  executePayment: (shipmentId: string, paymentMethod: string, paymentSource: PaymentSource) => Promise<TExecutePayment>;
};

const usePayment = (): TPaymentReturn => {
  const [isLoading, setIsLoading] = useState(false);

  const executePayment = useCallback(
    async (shipmentId: string, paymentMethod: string, paymentSource: PaymentSource) => {
      setIsLoading(true);

      const result = await submitPayment(shipmentId!, paymentMethod!, paymentSource);
      if (!result.isSuccess || !result.data) {
        setIsLoading(false);
        return { isSuccess: false, overDue: false };
      }

      // keep loading state while redirecting
      const { isPaid, paymentId, url, method, parameters, redirect, overDue } = result.data;

      if (isPaid) {
        // Order is already paid, just redirect to success page
        const redirectPath = getRedirectPath(paymentSource, paymentId, true);
        Router.push(redirectPath);
        return { isSuccess: true, overDue: overDue };
      }

      if (redirect) {
        Router.push(url || "");
        return { isSuccess: true, overDue: overDue };
      }

      if (!overDue) {
        submitDataAsForm({ url: url!, method: method!, data: parameters! });
      }

      if (overDue) {
        setIsLoading(false);
      }

      return { isSuccess: true, overDue: overDue };
    },
    []
  );

  return { isLoading, executePayment };
};
export default usePayment;
